import { Component, inject } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import translationsEN from "../assets/i18n/user-module/en.json";
import { ThemeService } from "./services/theme-service";
import { WishlistService } from "./services/wishlistService/wishlist.service";
import { CartItemService } from "./services/cart-item/cart-item.service";
import { AuthService } from "./features/auth/services/auth.service";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    imports: [RouterOutlet],
})
export class AppComponent {
    readonly themeService = inject(ThemeService);

    private translate = inject(TranslateService);
    private authService = inject(AuthService);
    private cartService = inject(CartItemService);
    private wishlistService = inject(WishlistService);

    constructor() {
        this.translate.setTranslation("en", translationsEN);
        this.translate.setFallbackLang("en");
    }

    ngOnInit(): void {
        const path = window.location.pathname;
        if (!(path.includes("admin") || path.includes("success"))) {
            if (this.authService.isUserAuthenticated()) {
                this.setItemsLocalStorage();
            } else {
                this.cartService.getCartItems().subscribe();
            }
        }
    }

    public setItemsLocalStorage() {
        this.wishlistService.loadMyWishlistItems();
        this.cartService.processCartItems(false);
    }
}
